module.exports = __webpack_public_path__ + "482c967e50fef21791147c113f4a4afb.png";